export default __webpack_public_path__ + "static/media/4.eb5fddc5.webp";